module.exports = __webpack_public_path__ + "static/media/varsity_flock_shadow.76cb1104.png";